import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { defaultInstance, HTTP_OPTIONS } from './setup';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getInstance = (_: string) => defaultInstance;

export const HTTP_STATUS_CODE = {
	ok: 200,
	badRequest: 400,
	unauthorized: 401,
	forbidden: 403,
	notFound: 404,
	internalServerError: 500
};

export const HTTP_HEADERS = {
	csrf: 'x-csrf-token'
};

export const get = async <T>(
	uri: string,
	options?: Partial<AxiosRequestConfig<T>>
): Promise<AxiosResponse<T>> => {
	const instance = getInstance(uri);
	const response = await instance.get<T>(uri, {
		...options,
		...HTTP_OPTIONS
	});
	return response;
};

export const post = async <T, R = T>(
	uri: string,
	body?: T,
	options?: Partial<AxiosRequestConfig<T>>
): Promise<AxiosResponse<R>> => {
	const b = body || {};
	const instance = getInstance(uri);
	const response = await instance.post<T, AxiosResponse<R>>(uri, b, {
		...options,
		...HTTP_OPTIONS
	});
	return response;
};

export const put = async <T, R = T>(
	uri: string,
	body?: T,
	options?: Partial<AxiosRequestConfig<T>>
): Promise<AxiosResponse<R>> => {
	const instance = getInstance(uri);
	const b = body || {};
	const response = await instance.put<T, AxiosResponse<R>>(uri, b, {
		...options,
		...HTTP_OPTIONS
	});
	return response;
};

export const del = async <T = any>(
	uri: string,
	options?: Partial<AxiosRequestConfig<T>>
): Promise<AxiosResponse<T>> => {
	const instance = getInstance(uri);
	const response = await instance.delete(uri, {
		...options,
		...HTTP_OPTIONS
	});
	return response;
};

export const postMultipart = async <T, R = T>(
	uri: string,
	file: Blob,
	options?: Partial<AxiosRequestConfig<T>>
): Promise<AxiosResponse<R>> => {
	const formData = new FormData();
	formData.append('file', file);

	const instance = getInstance(uri);
	const response = await instance.post<T, AxiosResponse<R>>(uri, formData, {
		...options,
		...HTTP_OPTIONS,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
	return response;
};
